import HelpCenter from './HelpCenter';
﻿// src/NavBarCommerciale.js — Header partagé pour toutes les pages commerciale
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { User } from 'lucide-react';
import GlobalSearch from './GlobalSearch';

const NavBarCommerciale = ({ urgentCount = 0, onAlertes, pageCourante = '' }) => {
  const navigate = useNavigate();
  const { profile, signOut } = useAuth();

  const handleSignOut = async () => { await signOut(); navigate('/login'); };

  const btnStyle = (active = false) => ({
    background: active ? 'white' : 'rgba(255,255,255,0.15)',
    border: '1px solid rgba(255,255,255,0.3)',
    color: active ? '#1e40af' : 'white',
    borderRadius: '8px', padding: '8px 14px', cursor: 'pointer',
    fontSize: '13px', fontWeight: active ? 600 : 400,
    transition: 'all 0.15s', display: 'inline-flex', alignItems: 'center', gap: '5px'
  });

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>

      {/* Recherche globale */}
      <GlobalSearch compact={false} />

      {/* Alertes */}
      <button
        onClick={onAlertes ? onAlertes : () => navigate('/quote-dashboard')}
        onMouseEnter={e => { e.currentTarget.style.background = urgentCount > 0 ? 'rgba(239,68,68,0.5)' : 'rgba(255,255,255,0.28)'; }}
        onMouseLeave={e => { e.currentTarget.style.background = urgentCount > 0 ? 'rgba(239,68,68,0.3)' : 'rgba(255,255,255,0.15)'; }}
        style={{
          background: urgentCount > 0 ? 'rgba(239,68,68,0.3)' : 'rgba(255,255,255,0.15)',
          border: `1px solid ${urgentCount > 0 ? 'rgba(239,68,68,0.6)' : 'rgba(255,255,255,0.3)'}`,
          color: 'white', borderRadius: '8px', padding: '8px 14px', cursor: 'pointer',
          fontSize: '13px', transition: 'all 0.15s', display: 'inline-flex', alignItems: 'center', gap: '6px'
        }}>
        🔔 Alertes
        {urgentCount > 0 && (
          <span style={{ background: '#ef4444', color: 'white', borderRadius: '999px', padding: '1px 7px', fontSize: '11px', fontWeight: 700 }}>
            {urgentCount}
          </span>
        )}
      </button>

      {/* Nom */}
      <span style={{ color: 'rgba(255,255,255,0.9)', fontSize: '14px', display: 'inline-flex', alignItems: 'center', gap: '5px' }}>
        <User size={13} /><span>{profile?.nom}</span>
        {profile?.role === 'manager' && (
          <span style={{ marginLeft: '6px', fontSize: '11px', background: 'rgba(255,255,255,0.2)', padding: '2px 8px', borderRadius: '999px' }}>Manager</span>
        )}
      </span>

      {/* Mes devis */}
      <button onClick={() => navigate('/quote-dashboard')}
        onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.28)'; }}
        onMouseLeave={e => { e.currentTarget.style.background = pageCourante === 'devis' ? 'white' : 'rgba(255,255,255,0.15)'; }}
        style={btnStyle(pageCourante === 'devis')}>
        📋 Mes devis
      </button>

      {/* Mes Factures */}
      <button onClick={() => navigate('/invoice-dashboard')}
        onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.28)'; }}
        onMouseLeave={e => { e.currentTarget.style.background = pageCourante === 'factures' ? 'white' : 'rgba(255,255,255,0.15)'; }}
        style={btnStyle(pageCourante === 'factures')}>
        🧾 Mes Factures
      </button>

      {/* Mes clients */}
      <button onClick={() => navigate('/quote-dashboard?vue=clients')}
        onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.28)'; }}
        onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.15)'; }}
        style={btnStyle(false)}>
        👥 Mes clients
      </button>

      {/* Nouveau devis */}
      <button onClick={() => navigate('/client-info')}
        onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.28)'; }}
        onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.15)'; }}
        style={btnStyle(false)}>
        + Nouveau devis
      </button>

      {/* Centre d'aide */}
      <HelpCenter />

      {/* Déconnexion */}
      <button onClick={handleSignOut}
        onMouseEnter={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.28)'; }}
        onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.15)'; }}
        style={btnStyle()}>
        Déconnexion
      </button>
    </div>
  );
};

export default NavBarCommerciale;
